import { EarnCodeHours, ForemanEarnCodeHours } from '../timekeeping';

export interface ForemanTimeImport {
  bDispatchSigned: boolean;
  lastName: string;
  last4SSN: string;
  laborTemplate: string;
  bDispatchActive: boolean;
  vpJobID: string;
  hasPerDiem: boolean;
  employeeCompanyID: number;
  jobID: string;
  bActiveState: boolean;
  perDiem: number;
  employeeJobID: string;
  employeeID: string;
  isBillableWorkOrder: boolean;
  workOrder: string;
  workOrderID: string;
  workOrderDescription: string;
  customerPO: string;
  shift: number;
  craft: string;
  shouldMoveOnsite: boolean;
  class: string;
  firstName: string;
  employeeVPID: string;
  employeeJobStepUpID: string;
  foremanSummary: ForemanTimeEntrySummary;
  isMapped: boolean;
  needsReimport?: boolean;
  foremanTimeImportID: string;

  labors: ForemanTimeImportLabor[];

  dateWorked: string;
  absentReasonID: string;
  absentReason: string;

  totalWeekHours: number;
  workingHours: EarnCodeHours[];
  nonWorkingHours: EarnCodeHours[];
  foremanWorkingHours: ForemanEarnCodeHours[];
  foremanNonWorkingHours: ForemanEarnCodeHours[];
}

export interface ForemanTimeImportLabor {
  earnCode: string;
  billRate?: number;
  earnCodeType: string;
  dateWorked: string;
  hours: number;
  factor: number;
  mileageType?: number;
  bActive?: boolean;
  payRate?: number;
  savedHours?: number;
  foremanEmployeeLaborID?: string;
  isMapped?: boolean;
  needsReimport?: boolean;
  notes?: string;
  employeeLaborID?: string;
}

export interface ForemanTimeImportAbsent {
  dateWorked: string;
  absentReasonID: string;
  absentReason: string;
}

export interface ForemanTimeEntrySummary {
  workOrder: string;
  shift: string;
  class: string;
  dispatchClass: string;
  foremanCrew: string;
  hw: number;
  st: number;
  ot: number;
  pt: number;
  vac: number;
  hol: number;
  trv: number;
  perDiem: boolean;
  lastDay: boolean;
  absentReason: string;
  absentReasonOther: string;
  notes: string;
  foremanEmployeeLaborIDs: string[];
  reviewedByDisplayName?: string;
  reviewedDate?: string;
}
